import { render, staticRenderFns } from "./EnglishResumePreviewDoc.vue?vue&type=template&id=40754edf"
import script from "./EnglishResumePreviewDoc.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnglishResumePreviewDoc.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports